import React, { useEffect, useRef, useState } from "react";

const Dashboard = ({ lang, layer_group_uuid }) => {
  const iframeRef = useRef(null);
  const [iframeHeight, setIframeHeight] = useState("1000px");

  useEffect(() => {
    const adjustIframeHeight = (event) => {
      console.log("adjustIframeHeight", event, event.data.iframeHeight);
      if (event.data.iframeHeight) {
        setIframeHeight(event.data.iframeHeight + "px");
      }
    };

    window.addEventListener("message", adjustIframeHeight);
    return () => {
      window.removeEventListener("message", adjustIframeHeight);
    };
  }, []);

  console.log("iframeHeight", iframeHeight);

  return (
    <div
      style={{
        padding: "1.5rem",
        borderRadius: "1.5rem",
        backgroundColor: "white",
      }}
    >
      <iframe
        ref={iframeRef}
        src={`${process.env.REACT_APP_API_URL}dashboard/carbon_sink_sp/?lang=${lang}&layer_group_uuid=${layer_group_uuid}`}
        style={{
          width: "100%",
          border: "none",
          height: "550px",
          // height: iframeHeight,
          // minHeight: "1000px",
        }}
      />
    </div>
  );
};

export default Dashboard;
